import React, { useState } from 'react';
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";

interface SortsProps {
    onUpdateSorts: (sorts: any[]) => void;
}

const Sorts: React.FC<SortsProps> = ({ onUpdateSorts }) => {
    const [rows, setRows] = useState<{
        dropdown1: string;
        dropdown2: string;
        sort: string;
    }[]>([
        // { dropdown1: '', dropdown2: '', sort: '' }
    ]);

    const handleDropdown1Change = (e: (EventTarget & HTMLInputElement) | (EventTarget & {
        value: string;
        name: string
    }) | (null & { value: unknown; name: string }), index: number) => {
        const updatedRows = [...rows];
        updatedRows[index].dropdown1 = e.value;
        updatedRows[index].sort = updatedRows[index].dropdown1.replaceAll('{c_o_l}', updatedRows[index].dropdown2)
            .replaceAll('{t_i_m_e}', Math.round(Date.now() / 1000).toString());
        setRows(updatedRows);
        onUpdateSorts(updatedRows);
    };

    const handleDropdown2Change = (e: (EventTarget & HTMLInputElement) | (EventTarget & {
        value: string;
        name: string
    }) | (null & { value: unknown; name: string }), index: number) => {
        const updatedRows = [...rows];
        updatedRows[index].dropdown2 = e.value;
        updatedRows[index].sort = updatedRows[index].dropdown1.replaceAll('{c_o_l}', updatedRows[index].dropdown2)
            .replaceAll('{t_i_m_e}', Math.round(Date.now() / 1000).toString());
        setRows(updatedRows);
        onUpdateSorts(updatedRows);
    };

    const handleAddRowClick = () => {
        setRows([...rows, { dropdown1: '', dropdown2: '', sort: '' }]);
    };

    const handleDeleteRowClick = (index: number) => {
        const updatedRows = [...rows];
        updatedRows.splice(index, 1);
        setRows(updatedRows);
        onUpdateSorts(updatedRows);
    };

    // @ts-ignore
    let columns = (globalThis.elasticSearchConditionColumns !== undefined ? globalThis.elasticSearchConditionColumns : [])
        .filter((option: { name: string }) => !option.name.startsWith('@'));

    return (
        <Container>
            Sorts
            {rows.map((row, index) => (
                <Container key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                    <select
                        value={row.dropdown1}
                        onChange={(e) => handleDropdown1Change(e.target, index)}
                        style={{ marginRight: '8px' }}
                    >
                        <option value="" disabled>Select sort</option>
                            <option value="sort[{t_i_m_e}][by]={c_o_l}&sort[{t_i_m_e}][dir]=ASC">ASC</option>
                            <option value="sort[{t_i_m_e}][by]={c_o_l}&sort[{t_i_m_e}][dir]=DESC">DESC</option>
                    </select>
                    <select
                        value={row.dropdown2}
                        onChange={(e) => handleDropdown2Change(e.target, index)}
                        style={{ marginRight: '8px' }}
                    >
                        <option value="" disabled>Select column</option>
                        <option key="aggregate-column" value="">aggregated column</option>
                        {columns.map((option: { name: string }) => (
                            <option key={option.name} value={option.name}>{option.name}</option>
                        ))}
                    </select>
                    <Button onClick={() => handleDeleteRowClick(index)}>{<DeleteIcon />}</Button>
                </Container>
            ))}
            <Button onClick={handleAddRowClick}>Add Sort</Button>
        </Container>
    );
};

export default Sorts;
